<div class="container">

    <h1>PRIVACY POLICY</h1>
    <h3>TV264 Internet Privacy Policy</h3>
    <p>TV264 respects the privacy of your information. This policy summarizes the personal information you provide to us
        and how we may use this information. This policy also explains other important issues regarding your privacy.
    </p>

    <h3>Contents</h3>
    <p>TV264 Internet Privacy Policy, Your consent, Limitations on the collection, use and disclosure of personal
        information, Information collected through the TV264 Software website and how this information can be used,
        Sharing of personal information, Security of personal information, Retention of personal information, Children
        and parents, This policy or Questions about privacy statements ,Changes to this policy and our privacy
        statements

    </p>


    <h3>Your consent</h3>
    <p>By using the TV264 website or providing us with personal information, you consent to the collection, use and
        disclosure of your personal information as described in this policy and any applicable country or website
        privacy statement.</p>

    <h3>Limitations on the collection, use and disclosure of personal information</h3>
    <p>Whenever TV264 collects personal information from the website, to the extent required by applicable law; He will
        keep you informed of his data practices in a timely and appropriate manner. It will collect, use and transmit
        your personal information with your explicit or confidential consent, depending on the sensitivity of the
        personal information, legal requirements and other factors. It will collect your personal information only for
        specific, limited purposes. The information we collect will be relevant, sufficient and not exaggerated for the
        purpose for which it was collected. It will process your personal information in a manner consistent with the
        purpose for which it was originally collected or for which you subsequently consented. It will take reasonable
        steps to ensure that your personal information is reliable, accurate, complete and, where necessary, up to date
        for its intended use. It will not use your personal information for direct marketing purposes without giving you
        the opportunity to “opt-out”. It will take appropriate measures to ensure that personal information disclosed to
        a third party or transmitted to another country, by contract or otherwise, including transmissions within TV264,
        is adequately protected.
        Information collected through the TV264 website and how this information can be used
    </p>

    <h3>When you use the TV264 website, we may collect information about you:</h3>
    <h3>1. Information sent to us by your web browser</h3>
    <p>TV264 collects information automatically sent to us by your web browser. This information typically includes the
        IP address of your internet service provider, the name of your operating system (such as Macintosh® or
        Windows®), and your web browser version (such as Internet Explorer® or Mozilla®). Please check your browser if
        you want to know what information your browser is sending or how to change your settings. The information
        provided by your browser does not personally identify you. We use this information to generate statistics that
        help us improve our site and make it more compatible with the technology used by our internet visitors.

    </p>

    <h3>2. Information collected by placing a "Cookie" on your computer</h3>
    <p>TV264 can collect information about you by installing a "tag" on your computer's hard drive. This tag is known as
        a "cookie". TV264 website uses “session cookies”. A session cookie is used to tag your computer with a unique,
        computer-generated identifier when you log into our site. A session cookie does not identify you personally and
        expires after you close your browser. We use session cookies to collect statistical information about the way
        our visitors use our site – which pages they visit, which links they use, and how long they stay on each page.
        We statistically analyze this (clickstream data) information to better understand the interests of our visitors
        and their need to improve the content and functionality of our site. If you do not want to receive cookies, you
        can set your browser to refuse or to warn you when a cookie is placed on your computer. Although you do not need
        to accept cookies when you visit a TV264 website, if your browser rejects cookies, you may not be able to use
        all functions of the site.</p>

    <h3>3. Information you knowingly and voluntarily provide</h3>
    <p>TV264 collects information that you knowingly and voluntarily provide when you use the website, for example;
        Information you provide when you sign up to receive email alerts, complete a survey, or ask a question or email
        us for feedback. In many cases, this information will be personal information. TV264 uses this information for
        your purpose of providing it. E.g; When you provide your e-mail address when you register to receive e-mail
        alerts, we use your e-mail address to send the e-mail alerts you request. We may use the information we collect
        from the TV264 website for a variety of business purposes, including customer service, fraud prevention, market
        research, improving our products and services, and providing you and your company with information and offers
        that we believe may be of interest to you. The TV264 site allows you to make choices about the use of your
        personal information. In many cases, we ask that you display your choices on the page and at the time you
        provide your personal information.</p>



    <h3>Sharing of personal information</h3>
    <p>TV264 will not sell the information it collects to mailing list agents without your express consent. TV264 does
        not share your personal information with other Intercode A.Ş. can be shared with business units. When we do
        this, this other Intercode Inc. units will use your information for the purpose for which it was originally
        collected (or with your subsequent consent) and only in accordance with this policy, in accordance with any
        applicable country or website privacy statements and all applicable privacy and data protection laws. In
        certain, limited circumstances, we may share or forward your personal information to unrelated third parties.
        E.g; to a third party (i) upon your request, (ii) to comply with a legal requirement or court order, (iii) to
        investigate a possible crime such as identity theft, (iv) to TV264 or Intercode A.Ş. in connection with the
        sale, acquisition, merger, reorganization, liquidation or dissolution of the business unit; or (v) similar
        circumstances. Should such an event occur, we will take appropriate steps to protect your personal information.
        The TV264 website allows you to make choices about the disclosure and/or transmission of your personal
        information. In many cases, we ask that you display your choices on the page and at the time you provide your
        personal information.</p>



    <h3>Security of personal information</h3>
    <p>Your personal information will generally be stored in TV264 databases. TV264 provides reasonable safeguards to
        protect the privacy, security and integrity of personal information. While we take security measures to help
        protect against unauthorized disclosure, misuse or alteration of your personal information, as this is the case
        with all computer networks connected to the Internet, we cannot guarantee the security of information provided
        over the Internet and will not be liable for breaches of security beyond our reasonable control.</p>


    <h3>Retention of personal information</h3>
    <p>TV264 retains the personal information collected through our website as much as necessary to provide the
        services, products and information you request or to the extent permitted by applicable law.</p>


    <h3>Questions about this policy or privacy statements</h3>
    <p>If you have any questions about this policy, a country, a website privacy statement, or our use of personal
        information, please contact info@TV264 by email.</p>



    <h3>Changes to this policy and our privacy statements</h3>
    <p>TV264 reserves the right to update or change this policy at any time and without prior notice in a revised
        version of this policy.</p>
</div>